import { TranslateService } from '@ngx-translate/core';
import { Injectable, inject } from '@angular/core';
import { ToastMessageOptions } from 'primeng/api';
import { BackendValidationErrorConfig, handleBackendValidationError } from '@app/shared/utils/error-handler.util';

const ERROR_REGEXS = [
  /^Invalid barcode for type (?<type>\w+): (?<value>\w+)$/i,
  /^Barcode value already assigned to another (?<type>\w+): (?<value>\w+)$/i,
  /^Barcode value and type must not be blank$/i,
  /^Duplicate barcode value within the same SKU request: (?<value>\w+)$/i,
  /^Duplicate barcode value across the request payload: (?<value>\w+)$/i,
]

const extractParamsFromError = (error: any) => {
  const errorMessage = error?.error?.message as string;
  if (!errorMessage) return undefined;

  for (const regex of ERROR_REGEXS) {
    const matched = errorMessage.match(regex)
    if (!matched) continue
    return matched.groups
  }

  return undefined;
}

@Injectable({ providedIn: 'root' })
export class SkuErrorService {
  private readonly translateService = inject(TranslateService);

  handleApiError(error: any, operation: 'update'): ToastMessageOptions {
    const params = extractParamsFromError(error)
    const config: BackendValidationErrorConfig = {
      defaultErrorKeys: {
        update: 'sku_management.edit.messages.update_error',
      },
      errorPatterns: [
        {
          patterns: ['Invalid barcode for type'],
          key: 'sku_management.barcode.messages.invalid_barcode_for_type',
          params,
        },
        {
          patterns: ['Barcode value already assigned to another'],
          key: 'sku_management.barcode.messages.barcode_inused',
          params,
        },
        {
          patterns: ['Barcode value and type must not be blank'],
          key: 'sku_management.barcode.messages.not_blank',
          params,
        },
        {
          patterns: ['Duplicate barcode value within the same SKU request'],
          key: 'sku_management.barcode.messages.duplicate_on_same_request',
          params,
        },
        {
          patterns: ['Duplicate barcode value across the request payload'],
          key: 'sku_management.barcode.messages.duplicate_on_across_request',
          params,
        },
      ],
    };

    return handleBackendValidationError(
      error,
      operation,
      config,
      this.translateService
    );
  }
}
